import * as React from "react";
import { Button } from "carbon-components-react";
import { Undo20 } from "@carbon/icons-react";

interface UndoButtonProps {
  handleOnClick: Function;
}

const UndoButton: React.FC<UndoButtonProps> = props => (
  <Button
    kind="tertiary"
    size="sm"
    onClick={props.handleOnClick}
    renderIcon={Undo20}
    style={{ marginTop: "10px" }}
  >
    Undo
  </Button>
);

export default UndoButton;
